import React, { useState, useRef, useEffect, useMemo } from 'react';
import PropTypes from 'prop-types';
// import { v4 as uuidV4 } from 'uuid';
import translate from '../../libs/i18n';

import Api from '../../libs/Api';

import { AddInstitutionFormStyle } from './AddInstitutionFormStyle';

import onlyNumbers from '../../utils/onlyNumbers';

import Button from '../Button/Button';
import InputField from '../InputField/InputField';
import SelectOptions from '../SelectOptions/SelectOptions';
// import { AddInstitutionStyle } from '../../pages/AddInstitution/AddInstitutionFormStyle';
import { useSelector } from 'react-redux';

import ImagePlaceHolderIcon from '../../assets/svgs/ImagePlaceHolderIcon';
import PlusIcon from '../../assets/svgs/PlusIcon';
import { cnpjMask } from '../../utils/cnpjMask';
import { cpfMask } from '../../utils/cpfMask';
import { telMask } from '../../utils/telMask';


const AddInstitutionForm = ({
  key,
  index,
  setActionComplete,
  setLoading,
  userOptions,
  setUserOptions,
  headquarterOptions,
  removeAddedNewInstitutionForm,
}) => {
  const inputFileRef = useRef();
  const language = useSelector((state) => state.settings.language);

  const [showForm, setShowForm] = useState(' hide');
  const [showAdminForm, setShowAdminForm] = useState(false);
  // const [userOptions, setUserOptions] = useState([]);

  const [name, setName] = useState('');
  const [cnpj, setCnpj] = useState('');
  const [number, setNumber] = useState('');
  const [address, setAddress] = useState('');
  const [complement, setComplement] = useState('');
  const [adminIDSelected, setAdminIDSelected] = useState('');
  const [city, setCity] = useState('');
  const [country, setCountry] = useState('');
  const [headquarters, setHeadquarters] = useState('');
  const [postCode, setPostCode] = useState('');

  const [image, setImage] = useState(null);
  const [imageError, setImageError] = useState('');

  const [adminName, setAdminName] = useState('');
  const [adminCPF, setAdminCPF] = useState('');
  const [adminAddress, setAdminAddress] = useState('');
  const [adminEmail, setAdminEmail] = useState('');
  const [code, setCode] = useState('');
  const [adminTelephone, setAdminTelephone] = useState('');
  const [adminCity, setAdminCity] = useState('');
  const [adminNumber, setAdminNumber] = useState('');
  const [adminPostCode, setAdminPostCode] = useState('');
  const [adminComplement, setAdminComplement] = useState('');

  const [nameAdminError, setNameAdminError] = useState('');
  const [cpfAdminError, setCpfAdminError] = useState('');
  const [emailAdminError, setEmailAdminError] = useState('');
  const [selectAdminError, setSelectAdminError] = useState('');

  const [nameError, setNameError] = useState('');
  const [cnpjError, setCnpjError] = useState('');
  const [addressError, setAddressError] = useState('');
  const [numberError, setNumberError] = useState('');
  const [complementError, setComplementError] = useState('');
  const [cityError, setCityError] = useState('');
  const [countryError, setCountryError] = useState('');
  const [postCodeError, setPostCodeError] = useState('');
  const [headquarterError, setHeadquarterError] = useState('');

  useEffect(() => {
    if (adminIDSelected) {
      setShowAdminForm(false);
      setAdminName('');
      setAdminCPF('');
      setAdminAddress('');
      setAdminEmail('');
      setAdminTelephone('');
      setAdminCity('');
      setAdminPostCode('');
      setAdminComplement('');
      setCode('');
      setAdminNumber('');
      setNameAdminError('');
      setCpfAdminError('');
      setEmailAdminError('');
      setSelectAdminError('');
    }
  }, [adminIDSelected]);

  const avatarImage = useMemo(() => {
    if (image) {
      return URL.createObjectURL(image);
    }

    return null;
  }, [image]);

  const handleRegisterInstitutionAdmin = async () => {
    const adminCpfOnlyNumbers = onlyNumbers(adminCPF);
    const adminTelephoneOnlyNumbers = onlyNumbers(adminTelephone);

    const addNewAdmin = {
      // Obrigatórios
      name: adminName,
      email: adminEmail,
      password: 'healthScan$2021',
      accepts_usage_terms: true,
      accepts_privacy_policy: true,
      is_active: true,

      // Opcionais
      type: 'RES',
      cpf: adminCpfOnlyNumbers,
      phone: adminTelephoneOnlyNumbers,
    };

    Api.registerUser(addNewAdmin).then((response) => {
      if (response.status === 201) {
        let userOptionsArray = userOptions;
        const userItem = {
          key: userOptionsArray.length,
          value: response.data.id,
          text: adminName,
        };
        userOptionsArray.push(userItem);
        setUserOptions(userOptionsArray);

        setLoading(false);
        setActionComplete({
          type: 'success',
          text: translate('newAdministratorSuccess',language),
        });
        setShowAdminForm(false);
        setAdminIDSelected(response.data.id);
      } else {
        setLoading(false);
        setActionComplete({
          type: 'error',
          text: translate('newAdministratorError',language),
        });

        if (response.data && response.data.name) {
          if (
            response.data.name.includes('This field may not be blank.')
          ) {
            setNameAdminError(translate('requiredField',language));
          }
        }

        if (response.data && response.data.cpf) {
          if (
            response.data.cpf.includes('This field may not be blank.')
          ) {
            setCpfAdminError(translate('requiredField',language));
          } else if (
            response.data.cpf.includes('Cpf deve conter somente 11 números.')
          ) {
            setCpfAdminError(translate('invalidFieldMustHave11Numbers',language));
          } else if (response.data.cpf.includes('Cpf must be unique')) {
            setCpfAdminError(translate('cpfAlreadyRegistered',language));
          }
        }

        if (response.data && response.data.email) {
          if (
            response.data.email.includes('This field may not be blank.')
          ) {
            setEmailAdminError(translate('requiredField',language));
          } else if (
            response.data.email.includes('Enter a valid email address.')
          ) {
            setEmailAdminError(translate('invalidEmail',language));
          } else if (
            response.data.email.includes(
              'Usuário with this email already exists.'
            )
          ) {
            setEmailAdminError(translate('emailAlreadyRegistered',language));
          }
        }
      }
    });

    return true;
  };

  const handleRegisterInstitution = async () => {
    const cnpjOnlyNumbers = onlyNumbers(cnpj);
    const CEPonlyNumbers = onlyNumbers(postCode);


    if (name.length > 255) {
      return setNameError(translate('nameTooLong',language));
    }else {
      setNameError('');
    }

    if (!name) {
      return setNameError(translate('theNameFieldiSRequired',language));
    } else {
      setNameError('');
    }

    if (cnpjOnlyNumbers.length != 14) {
      return setCnpjError(translate('invalidFieldMustHave14Numbers',language));
    }else {
      setCnpjError('');
    }

    if (!headquarters) {
      return setHeadquarterError(translate('requiredField',language));
    }else {
      setHeadquarterError('');
    }

    if (!cnpj) {
      return setCnpjError(translate('requiredField',language));
    }else {
      setCnpjError('');
    }

    if (number.length > 30) {
      return setNumberError(translate('invalidNumber',language));
    }else {
      setNumberError('');
    }

    if (complement.length > 255) {
      return setComplementError(
        translate('invalidValue',language)
      );
    }else {
      setComplementError('');
    }

    if (address.length > 255) {
      return setAddressError(
        translate('invalidValue',language)
      );
    }else {
      setAddressError('');
    }

    if (city.length > 255) {
      return setCityError(translate('invalidValue',language));
    }else {
      setCityError('');
    }

    if (country.length > 50) {
      return setCountryError(translate('invalidValue',language));
    }else {
      setCountryError('');
    }

    if (CEPonlyNumbers.length > 8) {
      return setPostCodeError(translate('invalidValue',language));
    }else {
      setPostCodeError('');
    }

    if (!adminIDSelected) {
      return setSelectAdminError(
        translate('mustSelectAdministrator',language)
      );
    }

    const newInstitution = new FormData();

    newInstitution.append('name', name);
    newInstitution.append('cnpj', cnpjOnlyNumbers);
    if (image) {
      newInstitution.append('image', image);
    }
    newInstitution.append('number', number);
    newInstitution.append('complement', complement);
    newInstitution.append('address', address);
    newInstitution.append('headquarters', headquarters);
    newInstitution.append('city', city);
    newInstitution.append('country', country);
    newInstitution.append('post_code', CEPonlyNumbers);

    newInstitution.append('admin', adminIDSelected);

    setLoading(true);

    const responseAddInstitution = await Api.postAddNewInstitution(
      newInstitution
    );

    setLoading(false);

    if (responseAddInstitution?.status === 201) {
      setActionComplete({
        type: 'success',
        text: translate('institutionSuccess',language),
      });
      removeAddedNewInstitutionForm();
    } else if (
      responseAddInstitution?.data?.admin?.includes(
        'This admin cannot be set in more than one institution'
      )
    ) {
      setActionComplete({
        type: 'error',
        text: translate('administratorAlreadyRegistered',language),
      });
    } else if (
      responseAddInstitution?.data?.cnpj?.includes('Cnpj must be unique')
    ) {
      setActionComplete({
        type: 'error',
        text: translate('cnpjAlreadyRegistered',language),
      });
    } else if (
      responseAddInstitution?.data?.image?.includes(
        'The submitted data was not a file. Check the encoding type on the form.'
      )
    ) {
      setImageError(translate('addAnImageFile',language));
    } else {
      setActionComplete({
        type: 'error',
        text: translate('errorRegisteringInstitution',language),
      });
    }

    return true;
  };

  const handleShowInsitution = () => {
    if (showForm) {
      setShowForm('');
    } else {
      setShowForm(' hide');
    }
  };

  const handleCancelAddInstitution = () => {
    setShowForm(false);
    setName('');
    setCnpj('');
    setNumber('');
    setAddress('');
    setComplement('');
    setAdminIDSelected('');
    setCity('');
    setCountry('');
    setHeadquarters('');
    setPostCode('');

    setAdminName('');
    setAdminCPF('');
    setAdminAddress('');
    setAdminEmail('');
    setAdminTelephone('');
    setAdminCity('');
    setAdminPostCode('');
    setAdminComplement('');
    setCode('');
    setAdminNumber('');
    setNameAdminError('');
    setEmailAdminError('');
    setSelectAdminError('');
  };

  const handleAddNewInstitutionResponsible = () => {
    setAdminIDSelected('');
    setShowAdminForm(true);
  };

  const handleChangeSelect = (value, options, setValue) => {
    const currentOption = options.find(
      (option) => `${option.value}` === `${value}`
    );

    if (currentOption) {
      setValue(currentOption.value);
    }
  };

  const handleUploadImage = (event) => {
    if (
      event &&
      event.target &&
      event.target.files &&
      event.target.files.length
    ) {
      if (event.target.files.length > 1) {
        setImageError(translate('canOnlyAddOneImage', language));
      } else {
        const currentImageFile = event.target.files[0];
        setImage(currentImageFile);
      }
    }

    inputFileRef.current.files = null;
  };

  return (
    <AddInstitutionFormStyle>
      <div className="register-institution-form">
        <h3 className="title-unit">
        {translate('Institution', language)} {index + 1}{' '}
          <button
            type="button"
            className="view-button"
            onClick={handleShowInsitution}
          >
            {showForm ? translate('seeLess', language) : translate('seeMore', language)}
          </button>
        </h3>

        {showForm ? (
          <div key={key} className={`form-container${showForm}`}>
            <h3 className="institution-data">{translate('institutionDetails', language)}</h3>
            <div className="register-institution-wrapper">
              <div className="register-unit-form">
                <div className="input-label-form">
                  <span className="label">{translate('name', language)} *</span>
                  <div className="input">
                    <InputField
                      type="text"
                      inputName="name"
                      value={name}
                      onChange={setName}
                      noMarginBottom
                    />
                    {nameError ? (
                      <p className="error-message">{nameError}</p>
                    ) : null}
                  </div>
                </div>
                <div className="input-label-form">
                  <span className="label">CNPJ *</span>
                  <div className="input">
                    <InputField
                      type="text"
                      inputName="name"
                      value={cnpj}
                      onChange={(val) => {
                        setCnpj(cnpjMask(val));
                      }}
                      noMarginBottom
                    />
                    {cnpjError ? (
                      <p className="error-message">{cnpjError}</p>
                    ) : null}
                  </div>
                </div>
                <div className="input-label-form">
                  <span className="label">{translate('country', language)}</span>
                  <div className="input">
                    <InputField
                      type="text"
                      inputName="country"
                      value={country}
                      onChange={setCountry}
                      noMarginBottom
                    />
                    {countryError ? (
                      <p className="error-message">{countryError}</p>
                    ) : null}
                  </div>
                </div>
                <div className="input-label-form">
                  <span className="label">{translate('city', language)}</span>
                  <div className="input">
                    <InputField
                      type="text"
                      inputName="city"
                      value={city}
                      onChange={setCity}
                      noMarginBottom
                    />
                    {cityError ? (
                      <p className="error-message">{cityError}</p>
                    ) : null}
                  </div>
                </div>
                <div className="input-label-form">
                  <span className="label">{translate('zipCode', language)}</span>
                  <div className="input">
                    <InputField
                      type="text"
                      inputName="postcode"
                      value={postCode}
                      onChange={setPostCode}
                      noMarginBottom
                    />
                    {postCodeError ? (
                      <p className="error-message">{postCodeError}</p>
                    ) : null}
                  </div>
                </div>
                <div className="input-label-form">
                  <span className="label">{translate('address', language)}</span>
                  <div className="input">
                    <InputField
                      type="text"
                      inputName="address"
                      value={address}
                      onChange={setAddress}
                      noMarginBottom
                    />
                    {addressError ? (
                      <p className="error-message">{addressError}</p>
                    ) : null}
                  </div>
                </div>
                <div className="number-complement">
                  <div className="input-label-form number">
                    <span className="label">{translate('number', language)}</span>
                    <div className="input number">
                      <InputField
                        type="text"
                        inputName="number"
                        value={number}
                        onChange={setNumber}
                        noMarginBottom
                      />
                      {numberError ? (
                        <p className="error-message">{numberError}</p>
                      ) : null}
                    </div>
                  </div>
                  <div className="input-label-form">
                    <span className="label">{translate('complement', language)}</span>
                    <div className="input">
                      <InputField
                        type="text"
                        inputName="complement"
                        value={complement}
                        onChange={setComplement}
                        noMarginBottom
                      />
                      {complementError ? (
                        <p className="error-message">{complementError}</p>
                      ) : null}
                    </div>
                  </div>
                </div>
                <div className="input-label-form select-add-responsible">
                  <span className="label">{translate('headquarters', language)} *</span>
                  <div className="input">
                    <SelectOptions
                      theme="soft-blue-outline"
                      id="role"
                      options={headquarterOptions}
                      value={headquarters}
                      onChange={(value) =>
                        handleChangeSelect(
                          value,
                          headquarterOptions,
                          setHeadquarters
                        )
                      }
                    />
                    {headquarterError ? (
                      <p className="error-message">{headquarterError}</p>
                    ) : null}
                  </div>
                </div>
                <div className="input-label-form select-add-responsible">
                  <span className="label">{translate('administrator', language)} *</span>
                  <div className="input">
                    <SelectOptions
                      theme="soft-blue-outline"
                      id="role"
                      options={userOptions}
                      value={adminIDSelected}
                      onChange={(value) =>
                        handleChangeSelect(
                          value,
                          userOptions,
                          setAdminIDSelected
                        )
                      }
                    />
                    {selectAdminError ? (
                      <p className="error-message">{selectAdminError}</p>
                    ) : null}
                  </div>
                </div>
                <button
                  type="button"
                  className="add-responsible"
                  onClick={handleAddNewInstitutionResponsible}
                >
                  {translate('addANewAdministrator', language)}
                </button>
              </div>
              <div className="logo-container">
                <span className="image-label">{translate('logoImage', language)}</span>
                <div
                  className="logo"
                  style={{
                    backgroundImage: avatarImage?.length
                      ? `url(${avatarImage})`
                      : '',
                  }}
                >
                  {!avatarImage?.length ? <ImagePlaceHolderIcon /> : null}
                  <div className="add">
                    <PlusIcon />
                  </div>
                  <input
                    ref={inputFileRef}
                    type="file"
                    className="input-file"
                    accept="*/png,.png, image/png, */png, .png, */jpeg,.jpeg, image/jpeg, */jpeg, .jpeg"
                    multiple
                    onChange={handleUploadImage}
                  />
                </div>
                <span className="add-logo">{translate('addLogo', language)}</span>
                {imageError ? (
                  <p className="error-message">{imageError}</p>
                ) : null}
              </div>
            </div>

            {showAdminForm ? (
              <div className="admin-form">
                <h3 className="title">{translate('administratorDetails', language)}</h3>
                <div className="form-container">
                  <fieldset className="personal-admin-data">
                    <div className="input-label-form">
                      <span className="label">{translate('name', language)} *</span>
                      <div className="input">
                        <InputField
                          type="text"
                          inputName="name"
                          value={adminName}
                          onChange={setAdminName}
                          noMarginBottom
                        />
                        {nameAdminError ? 
                          <p className="error-message">{nameAdminError}</p>
                         : null}
                      </div>
                    </div>
                    <div className="input-label-form">
                      <span className="label">CPF *</span>
                      <div className="input">
                        <InputField
                          type="text"
                          inputName="name"
                          value={adminCPF}
                          onChange={(val) => {
                            setAdminCPF(cpfMask(val));
                          }}
                          noMarginBottom
                        />
                        {cpfAdminError ? (
                          <p className="error-message">{cpfAdminError}</p>
                        ) : null}
                      </div>
                    </div>
                    <div className="input-label-form">
                      <span className="label">E-mail *</span>
                      <div className="input">
                        <InputField
                          type="text"
                          inputName="name"
                          value={adminEmail}
                          onChange={setAdminEmail}
                          noMarginBottom
                        />
                        {emailAdminError ? (
                          <p className="error-message">{emailAdminError}</p>
                        ) : null}
                      </div>
                    </div>
                    <div className="telephone">
                      <div className="input-label-form">
                        <span className="label">{translate('telephone', language)}</span>

                        <div className="inputs">
                          <div className="phone-code">
                            <SelectOptions
                              className="phone-code"
                              theme="soft-blue-outline"
                              name="role"
                              id="role"
                              options={[
                                {
                                  key: 0,
                                  value: '',
                                  text: '+00',
                                },
                                { key: 1, value: '+55', text: '+55' },
                                { key: 2, value: '+52', text: '+52' },
                              ]}
                              value={code}
                              onChange={(value) =>
                                handleChangeSelect(
                                  value,
                                  [
                                    {
                                      key: 0,
                                      value: '',
                                      text: '+00',
                                    },
                                    { key: 1, value: '+55', text: '+55' },
                                    { key: 2, value: '+52', text: '+52' },
                                  ],
                                  setCode
                                )
                              }
                            />
                          </div>
                          <div className="phone-number">
                            <InputField
                              type="text"
                              inputName="name"
                              value={telMask(adminTelephone)}
                              onChange={setAdminTelephone}
                              noMarginBottom
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </fieldset>
                  <fieldset className="address-admin-data">
                    <div className="input-label-form">
                      <span className="label">{translate('city', language)}</span>
                      <div className="input">
                        <InputField
                          type="text"
                          inputName="name"
                          value={adminCity}
                          onChange={setAdminCity}
                          noMarginBottom
                        />
                      </div>
                    </div>
                    <div className="input-label-form">
                      <span className="label">{translate('zipCode', language)}</span>
                      <div className="input">
                        <InputField
                          type="text"
                          inputName="name"
                          value={adminPostCode}
                          onChange={setAdminPostCode}
                          noMarginBottom
                        />
                      </div>
                    </div>
                    <div className="input-label-form">
                      <span className="label">{translate('address', language)}</span>
                      <div className="input">
                        <InputField
                          type="text"
                          inputName="name"
                          value={adminAddress}
                          onChange={setAdminAddress}
                          noMarginBottom
                        />
                      </div>
                    </div>
                    <div className="number-complement">
                      <div className="input-label-form number">
                        <span className="label">{translate('number', language)}</span>
                        <div className="input number">
                          <InputField
                            type="text"
                            inputName="name"
                            value={adminNumber}
                            onChange={setAdminNumber}
                            noMarginBottom
                          />
                        </div>
                      </div>
                      <div className="input-label-form">
                        <span className="label">{translate('complement', language)}</span>
                        <div className="input">
                          <InputField
                            type="text"
                            inputName="name"
                            value={adminComplement}
                            onChange={setAdminComplement}
                            noMarginBottom
                          />
                        </div>
                      </div>
                    </div>
                  </fieldset>
                </div>
                <div className="action-buttons">
                  <Button
                    type="button"
                    theme="light"
                    onClick={handleRegisterInstitutionAdmin}
                    text={translate('registerAdministrator', language)}
                  />
                </div>
              </div>
            ) : null}
            <div className="action-buttons">
              <div className="button-wrapper">
                <Button
                  type="button"
                  theme="lime-green"
                  onClick={handleRegisterInstitution}
                  text={translate('register', language)}
                />
              </div>
              <div className="button-wrapper">
                <Button
                  type="button"
                  theme="default"
                  onClick={handleCancelAddInstitution}
                  text={translate('cancel', language)}
                />
              </div>
            </div>
          </div>
        ) : null}
      </div>
    </AddInstitutionFormStyle>
  );
};

AddInstitutionForm.propTypes = {
  key: PropTypes.string.isRequired,
  index: PropTypes.number.isRequired,
  setActionComplete: PropTypes.isRequired,
  setLoading: PropTypes.func.isRequired,
  userOptions: PropTypes.arrayOf(PropTypes.object),
  setUserOptions: PropTypes.func.isRequired,
  headquarterOptions: PropTypes.arrayOf(PropTypes.object),
  removeAddedNewInstitutionForm: PropTypes.func.isRequired,
};

AddInstitutionForm.defaultProps = {
  userOptions: [],
  headquarterOptions: [],
};

export default AddInstitutionForm;
